import { call, put, select, takeLatest } from 'redux-saga/effects'
import { PatientInformationConstants } from '../../patientInformation/store/patientInformation.constants'
import { IPcr } from '../../pcr/store/pcr.types'
import { setPatientDemographics } from '../store/patientDemographics.actions'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { getPcrIdSelector } from '../../home/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { getServiceIdSelector } from '../../user/selectors'

export function* getPatientDemographics(pcrDoc: IPcr) {
  const patientDemographics = pcrDoc.patient?.patientDemographics
  if (patientDemographics && Object.keys(patientDemographics).length !== 0) {
    yield put(setPatientDemographics(patientDemographics))
  }
}

export function* preloadPCR() {
  const pcrID: string = yield select(getPcrIdSelector)
  const serviceId: string = yield select(getServiceIdSelector)
  if (!pcrID) return

  try {
    const pcrDocsService = new PcrDocsService(serviceId)
    const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
    yield call(getPatientDemographics, pcrDoc)
  } catch (e) {
    yield put(throwPcrException(`preloadPCR() error in getPatientDemographics.saga.ts: ${e}`))
  }
}

export function* getPatientDemographicsSaga() {
  yield takeLatest([PatientInformationConstants.REFRESH_PATIENT_DATA], performWithMutexHOG, preloadPCR)
}
